import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from 'app/services';

@Component({
    selector: 'admin-layout',
    templateUrl: 'admin.layout.html',
    styleUrls: ['admin.layout.scss'],
})
export class AdminLayout implements OnInit {

    constructor() { }

    ngOnInit() { }
}